module.exports = __webpack_public_path__ + "img/map-current-hub.bc4c9595.png";